import { DMNNM, DMN, OPRTR_ID, ReCAPTCHA__KEY } from './ops.js';

export const isDev = true; //window.location.host.split('.')[0].trim().toLowerCase() === 'dev';
const feedPrefix = 'feed';
const reportPrefix = 'report';

export const host = `${isDev?'dev.':''}${DMNNM}.${DMN}`;
export const hostapi = `https://api${isDev?'-dev':''}.${DMNNM}.${DMN}`;
export const SocketEndPoint = `https://${feedPrefix}${isDev?'-dev':''}.${DMNNM}.${DMN}`;
export const CasinoAPI = `https://api${isDev?'-dev':''}.clubcasinoz.com`;
export const ReportsAPI = `https://${reportPrefix}${isDev?'-dev':''}.${DMNNM}.${DMN}`
export const SentryKeyDsn = `https://32cd7241b46842718a8ead3fdf5507d5@o442524.ingest.sentry.io/6146970`;
export const deckHerosApi = `https://api${isDev?'-dev':''}.deckheroz.io`;
export const deckHerosAdminUrl = `https://admin${isDev?'-dev':''}.deckheroz.io`;
export const MASTER_REPORT = `https://${reportPrefix}${isDev?'-dev':''}.bethubs.com/`;
export const XORO_API = `https://api${isDev?'-dev':''}.xorope.io/api/`;

export const realGamesApi = `https://cg${isDev?'-dev':''}.bethubs.com`;

export const OPERATOR_ID = OPRTR_ID;

export const ReCAPTCHA_KEY = ReCAPTCHA__KEY;

export const staticContentsImagePath = "https://images.staticcontent.io";
export const staticContentsImagePathOnly = "staticcontent.io";
export const SportBattleBaseUrl = `https://sb${isDev?'-dev':''}.clubcasinoz.com/`;


// export const Base_URL = 'https://api-dev.radheexch.com';


// export const localhost = 'localhost';
// export const localhostapi = 'http://localhost:5551/api';
// export const localhostreports = 'http://127.0.0.1:5000/user';
// export const localSocketEndPoint = 'http://feed-dev.radheexch.com';
// // export const localImagePath ='https://dl.radheexch.com';

// export const qaServer = 'dev.radheexch.com';
// export const qaServerApi = 'https://api-dev.radheexch.com';
// export const qaSocketEndPoint = 'https://feed-dev.radheexch.com';
// export const qaCasinoAPI = 'https://api-dev.clubcasino.io';
// export const qaReportsAPI = 'https://report-dev.radheexch.com'
// export const qaSentryKeyDsn = "https://2eede2389e774bf591440223142f22cc@o442524.ingest.sentry.io/6265808";
// // export const qaImagePath ='https://dl.radheexch.com';

// export const livehost = 'radheexch.com';
// export const livehostapi = 'https://api.radheexch.com';
// export const liveSocketEndPoint = 'https://feed.radheexch.com';
// export const liveCasinoAPI = 'https://api.clubcasinoz.com';
// export const liveReportsAPI = 'https://report.radheexch.com'
// export const liveSentryKeyDsn = "https://32cd7241b46842718a8ead3fdf5507d5@o442524.ingest.sentry.io/6146970";
// // export const liveImagePath ='https://dl.radheexch.com';

// export const livehostrd = 'radheexchange.com';
// export const livehostapird = 'https://api.radheexchange.com';
// export const liveSocketEndPointrd = 'https://socket.radheexchange.com';
// export const liveCasinoAPIrd = 'https://api.bethubs.com'
// export const liveReportsAPIrd = 'https://report.radheexchange.com'
// export const liveSentryKeyDsnrd = "https://32cd7241b46842718a8ead3fdf5507d5@o442524.ingest.sentry.io/6146970";
// // // export const liveImagePathrd ='https://images.staticcontents.com';

// export const OPERATOR_ID = "RDE"

// export const ReCAPTCHA_KEY = "6Ld-SrAaAAAAAKPTAvYPMP3bWU-_3En7_UK09iII"

// export const staticContentsImagePath = "https://images.staticcontent.io";
// export const staticContentsImagePathOnly = "staticcontent.io";

// export const deckHerosApi = "https://api.deckheroz.io";
// export const deckHerosAdminUrl = "https://admin.deckheroz.io";
// export const MASTER_REPORT = "https://report.bethubs.com/";
// export const XORO_API = "https://api.xorope.io/api/";
// export const QA_XORO_API = "https://api-dev.xorope.io/api/";

// export const realGamesApi = "https://cg.bethubs.com"; //"https://games-dev.deckheros.com"
